import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function NotFoundRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    // Редиректим на страницу 404
    navigate('/404', { replace: true })
  }, [navigate])

  return null
}
